import { WrappedFormUtils } from "antd/lib/form/Form";

import { Row, Checkbox, Col, Input } from "antd";

import React from "react";

import _ from "lodash";
import { IDictItem } from "../model";

export const LearnChannelSelect: React.SFC<{
  form: WrappedFormUtils<any>;
  dicts: ReadonlyArray<IDictItem>;
  value?: string[];
  onChange?: (value: string[]) => void;
}> = props => {
  const { dicts, form, value = [], onChange } = props;
  return (
    <Row gutter={[16, 8]}>
      <Checkbox.Group value={value} onChange={onChange as any}>
        {_.map(dicts, dictItem => {
          const { entryKey, entryValue } = dictItem;
          return (
            <Col span={24} md={12} key={entryKey}>
              <Checkbox value={entryKey}>{entryValue}</Checkbox>

              {/** 额外的 Input 框 */}
              {entryKey === "recommend" && value.includes("recommend") && (
                <div className="BecomePartnerForm-customText">
                  {form.getFieldDecorator("recommend")(
                    <Input placeholder="请填写推荐人姓名" />
                  )}
                </div>
              )}

              {entryKey === "other" && value.includes("other") && (
                <div className="BecomePartnerForm-customText">
                  {form.getFieldDecorator("other")(
                    <Input placeholder="请填写其他原因" />
                  )}
                </div>
              )}
            </Col>
          );
        })}
      </Checkbox.Group>
    </Row>
  );
};
